var EtShippingText = class extends HTMLElement {
  constructor() {
    super();
    this._threshold = parseFloat(this.getAttribute('threshold').replace(/[^0-9.]/g, '')) * 100;
    this.setAttribute('threshold', this._threshold);
    this._onCartChanged = this._onCartChanged.bind(this);
  }

  static get observedAttributes() {
    return ['threshold', 'total-price'];
  }

  connectedCallback() {
    document.addEventListener('cart:change', this._onCartChanged);
  }

  disconnectedCallback() {
    document.removeEventListener('cart:change', this._onCartChanged);
  }

  attributeChangedCallback() {
    this._update();
  }

  get totalPrice() {
    return parseFloat(this.getAttribute('total-price'));
  }

  set totalPrice(value) {
    this.setAttribute('total-price', value);
  }

  _onCartChanged(event) {
    var cart = event.detail && event.detail.cart;
    if (!cart) return;
    var priceForItems = cart.items
      .filter(function(i) { return i.requires_shipping; })
      .reduce(function(s, i) { return s + i.final_line_price; }, 0);
    var cartDiscount = (cart.cart_level_discount_applications || [])
      .reduce(function(s, d) { return s + d.total_allocated_amount; }, 0);
    this.totalPrice = priceForItems - cartDiscount;
  }

  _update() {
    var totalPrice = this.totalPrice;
    var reached = !isNaN(totalPrice) && totalPrice >= this._threshold;
    var defaultEl = this.querySelector('[data-shipping-default]');
    var freeEl = this.querySelector('[data-shipping-free]');
    if (defaultEl) defaultEl.hidden = reached;
    if (freeEl) freeEl.hidden = !reached;
  }
};

if (!window.customElements.get('et-shipping-text')) {
  window.customElements.define('et-shipping-text', EtShippingText);
}
